import { IfmsRoute } from '../../../config/types';
import { ISFUsageReportView } from '../../oceanImport/routes';

const routes:Array<IfmsRoute> = [
  { path: '/isf/isfUsage', component: ISFUsageReportView },
];

export default routes;
